import { useQuery } from "react-query";
import { getAccountTransactionTypes } from "../api/transactions/getAccountTransactionTypes";
import { getAccountTransactionsCacheKey } from "./transactionsStore";

export const getAccountTransactionTypesCacheKey = (accountId: string) => [
  ...getAccountTransactionsCacheKey(accountId),
  "account-transaction-types",
];

export function useQueryGetAccountTransactionTypes(accountId: string) {
  return useQuery(getAccountTransactionTypesCacheKey(accountId), () =>
    getAccountTransactionTypes(accountId),
  );
}
